module.exports = __webpack_public_path__ + "media/images/swifticons/weather-thunderstorm-66090e979d3ab2aeee17efd9d4ef9c7b.svg";